import { withAsync } from '@atlassian/help-center-common-component/with-async';
import { lazyForPaint } from 'react-loosely-lazy';

export default withAsync({
    loader: lazyForPaint(() =>
        import(
            /* webpackChunkName: "async-unified-help-conversations-log" */ 'unified-help-center/src/pages/conversational-store/ConversationalStore'
        ).then(({ ConversationalStore }) => ConversationalStore)
    ),
});
